import { generateId } from '@freelancer/datastore/testing/helpers';
import { v4 as uuidv4 } from 'uuid';
import type { BusinessBuilderAttempt } from './business-builder-attempt.model';
import type { BusinessBuilderBlueprint } from '../business-builder/business-builder.model';
import { defaultPredictedSkills } from '../skills';

export interface GenerateBusinessBuilderAttemptOptions {
  readonly id?: string;
  readonly workspaceId?: number;
  readonly userId?: number;
  readonly intendedPaymentAmount?: number;
  readonly phaseIndex?: number;
  readonly projectCount?: number;
  readonly phasesData?: BusinessBuilderBlueprint;
}

export function generateBusinessBuilderAttemptObject({
  id = uuidv4(),
  workspaceId = generateId(),
  userId = generateId(),
  intendedPaymentAmount = 200,
  phaseIndex = 1,
  phasesData = generateBusinessBuilderPhasesData(),
  projectCount = 2,
}: GenerateBusinessBuilderAttemptOptions = {}): BusinessBuilderAttempt {
  return {
    id: uuidv4(),
    userId,
    intendedPaymentAmount,
    phaseIndex,
    projectCount,
    phasesData: JSON.stringify(phasesData),
    workspaceId,
    createdAt: Date.now(),
  };
}

export function generateBusinessBuilderPhasesData(): BusinessBuilderBlueprint {
  return {
    id: '123e4567-e89b-12d3-a456-426614174000',
    idea: 'I want to start rock climbing gym.',
    kickoff: 'Ready to scale your legacy!',
    category: 'health',
    attachments: [],
    phases: [
      {
        id: 'ph1a9rcllz',
        label: 'Market Research',
        projects: [
          {
            id: 'proj01mgmt',
            title: 'Competitor Analysis',
            descriptionPartOne: 'abcd',
            descriptionPartTwo: 'abcd'.repeat(10),
            minBudget: 250,
            maxBudget: 350,
            industryPrice: 800,
            minDays: 3,
            maxDays: 7,
            rating: 8,
            topDependency: 'Who are the main local competitors?',
            topQualification: 'Experience with market analysis',
            tasks: ['Research local competitors', 'Analyze pricing models'],
            skills: JSON.stringify(defaultPredictedSkills),
          },
          {
            id: 'proj07audn',
            title: 'Target Audience Study',
            descriptionPartOne: 'abcd',
            descriptionPartTwo: 'abcd',
            minBudget: 300,
            maxBudget: 400,
          },
          {
            id: 'proj07audn',
            title: 'Deployment',
            descriptionPartOne: 'abcd',
            descriptionPartTwo: 'abcd',
            minBudget: 300,
            maxBudget: 400,
          },
        ],
      },
      {
        id: 'ph2bclptrx',
        label: 'Facility Planning',
        projects: [
          {
            id: 'proj21cnfg',
            title: 'Design Gym Layout',
            descriptionPartOne: 'abcd',
            descriptionPartTwo: 'abcd',
            minBudget: 500,
            maxBudget: 750,
          },
          {
            id: 'proj89matr',
            title: 'Equipment Procurement',
            descriptionPartOne: 'abcd',
            descriptionPartTwo: 'abcd',
            minBudget: 700,
            maxBudget: 1050,
          },
          {
            id: 'proj89matr',
            title: 'Equipment Procurement',
            descriptionPartOne: 'abcd',
            descriptionPartTwo: 'abcd',
            minBudget: 700,
            maxBudget: 1050,
          },
        ],
      },
      {
        id: 'ph3bmntrp0',
        label: 'Marketing Launch',
        projects: [
          {
            id: 'proj41mbrt',
            title: 'Brand Identity Creation',
            descriptionPartOne: 'abcd',
            descriptionPartTwo: 'abcd',
            minBudget: 400,
            maxBudget: 600,
          },
          {
            id: 'proj65lngh',
            title: 'Digital Marketing Setup',
            descriptionPartOne: 'abcd',
            descriptionPartTwo: 'abcd',
            minBudget: 350,
            maxBudget: 500,
          },
          {
            id: 'proj89matr',
            title: 'Equipment Procurement',
            descriptionPartOne: 'abcd',
            descriptionPartTwo: 'abcd',
            minBudget: 700,
            maxBudget: 1050,
          },
        ],
      },
    ],
  };
}
